import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";
import { buildWeatherApiPath } from "@catchy/app-core";
const fetcher = url => fetch(url).then(res => res.json());
export default function WeatherWidget(t0) {
  const $ = _c(10);
  const {
    lat,
    long,
    isDark
  } = t0;
  let t1;
  if ($[0] !== lat || $[1] !== long) {
    t1 = buildWeatherApiPath(lat, long);
    $[0] = lat;
    $[1] = long;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const weatherApiPath = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      refreshInterval: 900000,
      revalidateOnFocus: false
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: weather
  } = useSWR(weatherApiPath, fetcher, t2);
  const t3 = `align-items: center; flex min-w-[90px] flex-shrink-0 items-center justify-end pr-5 pt-1 text-2xl transition-opacity duration-500 ${weather ? "opacity-100" : "opacity-0"}`;
  let t4;
  if ($[4] !== isDark || $[5] !== weather) {
    t4 = weather && <><picture className="mr-1.5"><img src={`/icons/weather/${isDark ? "dark" : "light"}/${weather.icon}.svg`} alt={weather.description} /></picture><div className="text-zinc-700 dark:text-zinc-300">{Math.round(weather?.temp)}°</div></>;
    $[4] = isDark;
    $[5] = weather;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}